import { render, staticRenderFns } from "./TestingCKEditor.vue?vue&type=template&id=10136306&"
import script from "./TestingCKEditor.vue?vue&type=script&lang=js&"
export * from "./TestingCKEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports